// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1pYzs","imageUploader":"EGiftCard_imageUploader__2L9ql"};